export enum FrameworkResource {
    USER = 'user',
    GROUP = 'group',
    ROLE = 'role',
    USER_GROUP = 'user-group',
    USER_ROLE = 'user-role',
    AUTHENTICATION = 'authentication',
    JOB = 'job',
    NODE_INSTANCE = 'node-instance',
    AUDIT_EVENT = 'audit-event',
    OPTION = 'option',
    SCHEDULED_TASK = 'scheduled-task',
}
